import { Link } from "react-router";
import { useTranslation } from "react-i18next";
import Navbar from "../Navbar";
import Footer from "../Footer";

import "./style.css";

const pastContributors = [
    "Arnaud Derbey",
    "Laura Duparc",
    "Eliot Hallak",
    "Ashad Hosenbocus",
];

const currentContributors = ["Sacha Raoult", "Hamza Hoummadi"];

export default function Credits() {
    const { t } = useTranslation();

    return (
        <div className="credits-page">
            <Navbar />
            <main className="credits-main">
                <div className="credits-content">
                    <header className="credits-intro">
                        <p className="credits-eyebrow">thesis.center</p>
                        <h1>{t("credits-title")}</h1>
                        <p className="credits-description">
                            {t("credits-description")}
                        </p>
                    </header>

                    <div className="credits-contributors">
                        <section className="credits-group" aria-labelledby="credits-past-heading">
                            <h2 id="credits-past-heading">
                                {t("credits-past-contributors")}
                            </h2>
                            <ul>
                                {pastContributors.map((name) => (
                                    <li key={name}>{name}</li>
                                ))}
                            </ul>
                        </section>

                        <section className="credits-group" aria-labelledby="credits-current-heading">
                            <h2 id="credits-current-heading">
                                {t("credits-current-contributors")}
                            </h2>
                            <ul>
                                {currentContributors.map((name) => (
                                    <li key={name}>{name}</li>
                                ))}
                            </ul>
                        </section>
                    </div>

                    <Link className="credits-home" to="/">
                        {t("credits-home")}
                    </Link>
                </div>
            </main>
            <Footer />
        </div>
    );
}
